import React from 'react';

const StepHeader = ({ icon: Icon, title, description }) => (
  <div className="px-2 text-center sm:px-0">
    <Icon className="mx-auto h-10 w-10 text-gray-400 sm:h-12 sm:w-12" />
    <h2 className="mt-3 text-base font-medium text-gray-900 sm:mt-4 sm:text-lg">{title}</h2>
    <p className="mt-2 text-sm text-gray-600">{description}</p>
  </div>
);

export default StepHeader;
